import React, { useEffect } from 'react';
import './AchievementPopups.css';

const AchievementPopups = ({ type, value, activityType, onClose }) => {
  const getXPMessage = (activityType, xpValue) => {
    switch (activityType) {
      case 'daily_checkin':
        return {
          title: `You've earned ${xpValue}XP`,
          subtitle: 'for checking in today!'
        };
      case 'profile_picture':
        return {
          title: `You've earned ${xpValue}XP`,
          subtitle: 'for adding a profile picture!'
        };
      case 'skin_quiz':
        return {
          title: `You've earned ${xpValue}XP`,
          subtitle: 'well done on completing your skin profile!'
        };
      case 'curu_chat_post':
      case 'product_tag':
        return {
          title: `You've earned ${xpValue}XP`,
          subtitle: 'for creating a post in curu chats!'
        };
      case 'product_review':
      case 'photo_review':
        return {
          title: `You've earned ${xpValue}XP`,
          subtitle: 'for writing a product review!'
        };
      default:
        return {
          title: `You've earned ${xpValue}XP`,
          subtitle: 'Great job! Keep engaging to earn more experience points.'
        };
    }
  };

  console.log('AchievementPopups received:', { type, value, activityType }); 
  console.log('Message will be:', getXPMessage(activityType, value)); 

  // Handle escape key press to close popup
  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleEscapeKey);
    return () => document.removeEventListener('keydown', handleEscapeKey);
  }, [onClose]);

  // Handle click outside popup to close
  const handleOverlayClick = (event) => {
    if (event.target === event.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="achievement-popup-overlay" onClick={handleOverlayClick}>
      <div className="achievement-popup" role="dialog" aria-modal="true" aria-labelledby="popup-title">
        <button 
          className="popup-close-btn" 
          onClick={onClose}
          aria-label="Close popup"
        >
          ×
        </button>
        
        {type === 'level' ? (
          <>
            <div className="popup-level-badge">LEVEL {value}</div>
            <div className="popup-icon-container">
              <div className="popup-icon-bg">
                <img 
                  src="/images/icons/win.png" 
                  alt="Trophy icon"
                  className="popup-icon-image"
                />
              </div>
            </div>
            <h2 id="popup-title" className="popup-title">
              You've reached new level!
            </h2>
            <p className="popup-description">
              Congratulations! You've unlocked new features and rewards.
            </p>
          </>
        ) : (
          <>
            <div className="popup-xp-badge">{value}XP</div>
            <div className="popup-icon-container">
              <div className="popup-icon-bg">
                <img 
                  src="/images/icons/100xp.png" 
                  alt="Medal icon"
                  className="popup-icon-image"
                />
              </div>
            </div>
            <h2 id="popup-title" className="popup-title">
              {getXPMessage(activityType, value).title}
            </h2>
            <p className="popup-description">
              {getXPMessage(activityType, value).subtitle}
            </p>
          </>
        )}
        
        <button className="popup-close-button" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
};

export default AchievementPopups;